// extracted by mini-css-extract-plugin
export default {"categoryFilter":"styles_categoryFilter__jz1+O"};